<template>
  <b-card no-body>
    <!-- title and dropdown -->
    <b-card-header class="pb-0">
      <b-card-title>Resumo de Contratos</b-card-title>
    </b-card-header>
    <!--/ title and dropdown -->
    <b-card-body>
      <b-row>
        <b-col
          sm="2"
          class="d-flex flex-column flex-wrap text-center"
        >
          <h1 class="font-large-2 font-weight-bolder mt-2 mb-0">
            {{ acordosDoMes }}
          </h1>
          <b-card-text class="mb-2">
            Contratos
          </b-card-text>
        </b-col>

        <!-- chart -->
        <b-col
          sm="10"
          class="d-flex justify-content-center "
        />
        <!--/ chart -->
      </b-row>

      <!-- chart info -->
      <div class="d-flex justify-content-between">
        <div class="text-center">
          <b-card-text class="mb-50">
            Acordos Concluídos
          </b-card-text>
          <span class="font-large-1 font-weight-bold">{{ acordosConcluidos }}</span>
        </div>
        <div class="text-center">
          <b-card-text class="mb-50">
            Acordos Cancelados
          </b-card-text>
          <span class="font-large-1 font-weight-bold">{{ acordosCancelados }}</span>
        </div>
        <div class="text-center">
          <b-card-text class="mb-50">
            Acordos em Andamento
          </b-card-text>
          <span class="font-large-1 font-weight-bold">{{ acordosEmAndamento }}</span>
        </div>
      </div>

      <!-- Modal -->
      <b-modal
        ref="metaModal"
        title="Alterar Meta Mensal"
        ok-title="Salvar"
        cancel-title="Cancelar"
        @ok="salvarMeta"
        @cancel="fecharModal"
      >
        <b-form-group
          label="Nova Meta:"
          label-for="novaMeta"
        >
          <b-form-input
            id="novaMeta"
            v-model="novaMetaMensal"
            type="number"
            placeholder="Digite a nova meta mensal"
          />
        </b-form-group>
      </b-modal>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BRow, BCol, BCardText, BModal, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { $themeColors } from '@themeConfig'
import axios from '@/../axios-auth'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      faturamento: 0,
      acordosDoMes: 0,
      acordosConcluidos: 0,
      acordosCancelados: 0,
      acordosEmAndamento: 0,
      metaMensal: 320000, // Valor padrão da meta, ajuste conforme necessário
      novaMetaMensal: null, // Para o valor dentro do modal
      supportTrackerRadialBar: {
        series: [0],
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 20,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '65%',
              },
              track: {
                background: '#161d31',
                strokeWidth: '100%',
              },
              dataLabels: {
                name: {
                  offsetY: -5,
                  color: '#6b717f',
                  fontSize: '1rem',
                },
                value: {
                  offsetY: 15,
                  color: '#fff',
                  fontSize: '1.714rem',
                },
              },
            },
          },
          colors: [$themeColors.voz],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'radial',
              shadeIntensity: 1,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [50, 100],
            },
          },
          stroke: {
            dashArray: 8,
          },
          labels: ['Meta Mensal'],
        },
      },
    }
  },
  computed: {
    diasRestantes() {
      const hoje = new Date()
      const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).getDate()
      return ultimoDia - hoje.getDate()
    },
    // Calcula a porcentagem com base na nova meta
    porcentagemMeta() {
      return this.metaMensal > 0 ? ((this.faturamento / this.metaMensal) * 100).toFixed(2) : 0
    },

  },
  watch: {
    porcentagemMeta(newVal) {
      this.supportTrackerRadialBar.series = [parseFloat(newVal)] // Atualiza o gráfico
    },
    metaMensal(newVal) {
      localStorage.setItem('metaMensal', newVal)
    },
  },
  created() {
    const savedMetaMensal = localStorage.getItem('metaMensal')
    if (savedMetaMensal) {
      this.metaMensal = parseFloat(savedMetaMensal)
    }
    this.buscarDados()
    this.getTotalFaturamento()
  },
  methods: {
    buscarDados() {
      axios.get('/api/v1/acordo/listar/chart_data')
        .then(res => {
          const { dados } = res.data
          this.acordosDoMes = dados.acordos_do_mes
          this.acordosConcluidos = dados.acordos_concluidos
          this.acordosCancelados = dados.acordos_cancelados
          this.acordosEmAndamento = dados.acordos_em_andamento
        })
        .catch(error => {
          this.$toast({
            component: 'b-toast',
            props: {
              title: 'Erro',
              variant: 'danger',
              solid: true,
            },
            content: `Erro ao obter dados: ${error.message || 'Desconhecido'}`,
          })
        })
    },
    getTotalFaturamento() {
      axios.get('api/v1/dashboard/faturamento/mensal', {
        headers: {
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          accept: 'application/json',
        },
      }).then(res => {
        this.faturamento = res.data.dados[0].total_faturamento
      })
    },
    abrirModal() {
      this.novaMetaMensal = this.metaMensal // Preenche o input do modal com a meta atual
      this.$refs.metaModal.show()
    },
    fecharModal() {
      this.$refs.metaModal.hide()
    },
    salvarMeta() {
      // valida se é um numero
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(parseFloat(this.novaMetaMensal)) || !isFinite(this.novaMetaMensal)) {
        // eslint-disable-next-line no-alert
        alert('Por favor, insira um número válido para a meta.')
        return
      }
      this.metaMensal = parseFloat(this.novaMetaMensal) // Atualiza a meta
      this.fecharModal()
      this.getTotalFaturamento()
    },
  },
}
</script>
